import React from 'react';
import { useSelector } from 'react-redux';
import { Loader } from 'Components/Loader';
import './Overlay.css';

export default function Overlay() {
  const { showOverlay, overlayMessage, showOverlayLoader } = useSelector((s) => s.pageLayout);

  if (!showOverlay) return null;

  return (
    <div className="overlay show">
      {overlayMessage && <h3 className="overlayMessage">{overlayMessage}</h3>}
      {showOverlayLoader && (
        <div className="overlayLoader">
          <Loader />
        </div>
      )}
    </div>
  );
}
